const isLocalStorageAvailable = () => {
  if (typeof localStorage !== 'undefined') {
    try {
      localStorage.setItem('feature_test', 'yes');
      if (localStorage.getItem('feature_test') === 'yes') {
        localStorage.removeItem('feature_test');
        return true;
      }
      return false;
    } catch (e) {
      return false;
    }
  } else {
    return false;
  }
};

export default isLocalStorageAvailable;
